import React from "react";

interface ModeRendererProps {
  brand: string;
  today: string;
  Copy: string;
}

export function VasarelyVeoliaMode({ brand }: ModeRendererProps) {
  const width = 794;
  const height = 1123;

  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="veoliaGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "#00A3E0", stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: "#0077C0", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#B2E0F5", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <rect width={width} height={height} fill="url(#veoliaGradient)" />
      <g transform={`translate(${width / 2}, ${height / 2})`}>
        {Array.from({ length: 10 }).map((_, loop) => {
          const angle1 = (loop / 10) * 2 * Math.PI;
          const angle2 = angle1 + Math.PI * 1.5;
          const radius = 80 + loop * 35;
          const x1 = Math.cos(angle1) * radius;
          const y1 = Math.sin(angle1) * radius;
          const x2 = Math.cos(angle2) * radius;
          const y2 = Math.sin(angle2) * radius;
          return (
            <path
              key={`loop-${loop}`}
              d={`M ${x1},${y1} A ${radius},${radius} 0 1,1 ${x2},${y2}`}
              fill="none"
              stroke="#00A3E0"
              strokeWidth={2}
              opacity={0.3}
            />
          );
        })}
        {Array.from({ length: 18 }).map((_, r) => (
          <circle
            key={`recycle-${r}`}
            cx={0}
            cy={0}
            r={(r + 1) * 22}
            fill="none"
            stroke="#FFFFFF"
            strokeWidth={r % 3 === 0 ? 2.5 : 1.5}
            opacity={0.3 - r * 0.012}
          />
        ))}
        <circle cx={0} cy={0} r={50} fill="none" stroke="#00A3E0" strokeWidth={3} opacity={0.6} />
        <circle cx={0} cy={0} r={35} fill="#0077C0" opacity={0.4} />
      </g>
    </svg>
  );
};
